module.exports = __webpack_public_path__ + "static/media/Debit.34ed471a.svg";